<template>
  <div class="">
    <button class="btn-indigo w-32 font-normal" @click="openModal()">Floify</button>
    <ModalHeadlessUI ref="modal">
      <template #default>
        <h1 class="font-bold mb-4 text-3xl text-center">
          Start New Loan in Floify
        </h1>
        <div class="px-10">
          <form id="form" name="form" @submit.prevent="sendFloify">
            <text-input v-model="form.fullName" :error="form.errors.fullName" class="pr-6 pb-4 w-full" label="Full Name" />
            <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-2 w-full" label="Email" />
            <phone-input v-model.phoneFormat="form.phone" :type="phone" :error="form.errors.phone" class="relative pr-6 pb-2 w-full" label="Phone" />
            <text-input v-model="form.fullNameCoborrower" :error="form.errors.fullNameCoborrower" class="pr-6 pb-4 w-full" label="Co-Borrower Full Name" />
            <text-input v-model="form.emailCoborrower" :error="form.errors.emailCoborrower" class="pr-6 pb-4 w-full" label="Co-Borrower Email" />
            <phone-input v-model.phoneFormat="form.phoneCoborrower" :type="phone" :error="form.errors.phoneCoborrower" class="relative pr-6 pb-2 w-full" label="Co-Borrower Phone" />
            <text-input v-model="form.address" :zillow="zillow" :error="form.errors.address" class="relative pr-6 pb-4 w-full" label="Address" />
            <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-4 w-full" label="City" />
            <text-input v-model="form.state" :error="form.errors.state" class="pr-6 pb-4 w-full" label="State" />
            <text-input v-model="form.zip" :error="form.errors.zip" class="pr-6 pb-4 w-full" label="Zip" />

            <div class="flex justify-center pr-6 pb-4 w-full">
              <div class="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
                <input id="coborrowerUseBorrowerEmail" v-model="form.coborrowerUseBorrowerEmail" :true-value="1" :false-value="0" name="coborrowerUseBorrowerEmail" type="checkbox" class="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer" />
                <label for="coborrowerUseBorrowerEmail" class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer" />
              </div>
              <label for="coborrowerUseBorrowerEmail">Co-Borrower uses Borrower Email</label>
            </div>

            <label class="font-bold font-lg pb-2">Document Needs List:</label>
            <div style="overflow-y: scroll; height:200px;" class="mt-2">
              <div class="table-auto">
                <table id="doctable" class="w-full whitespace-nowrap">
                  <thead>
                    <tr id="tableheader" class="bg-gray-100">
                      <th>
                        <input id="checkboxToCheckAll" v-model="allSelected" class="m-2 w-5 h-5" type="checkbox" @click="selectAll" />
                      </th>
                      <th class="pl-5 font-bold pt-4 pb-4">
                        Document Name
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in list" :key="index" class="flex-inline even:bg-gray-100">
                      <td>
                        <input v-model="form.filenames" class="m-2 w-5 h-5" type="checkbox" :value="item" />
                      </td>
                      <td class="pl-5 font-sm my-2">
                        {{ item }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="py-2">
                  <span class="font-bold font-lg pb-2 mb-2">One Off Documents:</span>
                  <text-input v-model="oneOff" class="pr-6 pt-2 pb-2 w-full" />
                  <span type="button" class="cursor-pointer py-2 text-center btn-indigo ml-auto" @click="addToList">Add To List</span>
                </div>
              </div>
            </div>
            <div class="flex justify-center items-center mt-5">
              <div>
                <loading-button :loading="form.processing" class="cursor-pointer btn-indigo ml-auto" type="submit">Send Floify</loading-button>
              </div>
            </div>
          </form>
        </div>
      </template>
    </ModalHeadlessUI>
  </div>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import PhoneInput from '@/Shared/PhoneInput'
import { router } from '@inertiajs/vue3'

export default {
  components: {
    ModalHeadlessUI,
    PhoneInput,
    SelectInput,
    TextInput,
    LoadingButton,
  },
  props: {
    lead:{
      type: Object,
      default: null,
    },
    auth:{
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: router.form({
        id: this.lead.id,
        fullName: this.lead.fullName,
        email: this.lead.email,
        phone: this.lead.phone,
        fullNameCoborrower: this.lead.fullNameCoborrower,
        emailCoborrower: this.lead.emailCoborrower,
        phoneCoborrower: this.lead.phoneCoborrower,
        address: this.lead.address,
        city: this.lead.city,
        state: this.lead.state,
        zip: this.lead.zip,
        coborrowerUseBorrowerEmail: false,
        filenames:[],
      }),
      list: ['1003 - Loan Application', 'Driver\'s License', 'W-2s - Last 2 Years', 'Pay Stubs - Received in Last 30 Days', 'Bank Statements - Last 2 Months', 'Social Security Card', 'Evidence of Insurance', 'Home Owners Insurance Quote', 'Mortgage Statement(s)', '12 Months Rental History', 'Asset Statements: 401k, IRA, Retirement accounts', 'Bank Statements - Checking/Savings', 'Federal Tax Returns - Last 2 Years', 'Business Tax Returns', 'Business Tax Returns - Last 2 Years', 'Copy of Lease', 'DD Form 214', 'Divorce Decree', 'Homeowners Insurance Info', 'Final Closing Statements', 'HOA statement (if applicable)', 'K-1 Statements', 'Pension Statement', 'Social Security Award Letter', 'YTD Profit & Loss and Balance Sheet'],
      allSelected: false,
      oneOff: '',
    }
  },
  computed:{
  },
  methods:{
    addToList() {
      this.list.push(this.oneOff)
      this.form.filenames.push(this.oneOff)
      this.oneOff = ''
    },
    selectAll: function() {
      this.form.filenames = []
      var obj = this.list
      if (!this.allSelected) {
        //push selected array
        Object.keys(obj).forEach(key => {
          this.form.filenames.push(obj[key])
        })
      }

    },
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    sendFloify() {
      this.form.post('/floify', {
        onSuccess: () => {
          this.closeModal()
        },
      })
    },
  },
}
</script>
<style>
/* CHECKBOX TOGGLE SWITCH */
/* @apply rules for documentation, these do not work as inline style */
.toggle-checkbox:checked {
  right: 0;
  border-color: #68D391;
}
.toggle-checkbox:checked + .toggle-label {
  background-color: #68D391;
}
</style>

